import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateClassificationTypeMutation } from '../../../generated/graphql';
import { FormField } from '../../form';
import styles from './NewClassificationTypeDialog.module.css';

type NewClassificationTypeDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewClassificationTypeDialog = (props: NewClassificationTypeDialogProps) => {
    const { style, visible, onClose } = props;
    const [createType, createTypeResult] = useCreateClassificationTypeMutation();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const nameError = submitted && !name.trim() ? 'Name is required.' : '';
    const descriptionError = submitted && !description.trim() ? 'Description is required.' : '';

    const handleSubmit = () => {
        setSubmitted(true);
        if (!name.trim() || !description.trim()) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createType({
            variables: {
                classificationType: { name: name.trim(), description: description.trim() }
            }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            isLoading={createTypeResult.loading}
            title="New Classification Table"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewClassificationTypeDialog}
            style={style}
            data-testid="NewClassificationTypeDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} required error={nameError} />
            <FormField label="Description" name="description" value={description} onChange={setDescription} required error={descriptionError} />
        </DialogBase>
    );
};

export default NewClassificationTypeDialog;